/**
 * Mutations of the store inbound-sms module.
 *
 * @module store/inbound-sms/mutations
 * @author Dilan Useche <dilan8810@gmail.com>
 * */
export default {
};
